import { c as _c } from "react/compiler-runtime";
import { ChevronLeft } from 'lucide-react';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { TestimonialSection } from './testimonial-section';
import { Button } from '@/components/ui/button';
import { SETTINGS_TABS } from '@/lib/constants';
import { cn } from '@/lib/utils';
import { buildSettingsPath } from '@/utils/app-paths';
type PricingPageShellProps = {
  title: string;
  subtitle?: string;
  headerExtra?: ReactNode;
  containerClassName?: string;
  children: ReactNode;
};
export function PricingPageShell(t0) {
  const $ = _c(20);
  const {
    title,
    subtitle,
    headerExtra,
    containerClassName,
    children
  } = t0;
  let t1;
  if ($[0] !== containerClassName) {
    t1 = cn("mx-auto w-full px-4 py-8 lg:py-22", containerClassName);
    $[0] = containerClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mx-auto mb-2 max-w-3xl"><Button variant="ghost" size="sm" className="-ml-2 text-zinc-400 hover:bg-muted/25 hover:underline" asChild={true}><Link href={buildSettingsPath({
          tab: SETTINGS_TABS.BILLING
        })}><ChevronLeft className="mr-1 h-4 w-4" />Back</Link></Button></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <h1 className="text-3xl font-medium">{title}</h1>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== subtitle) {
    t4 = subtitle && <p className="mt-2 text-base text-zinc-400">{subtitle}</p>;
    $[5] = subtitle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== headerExtra) {
    t5 = headerExtra && <div className="mt-6 flex justify-center">{headerExtra}</div>;
    $[7] = headerExtra;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className="mb-8 text-center">{t3}{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TestimonialSection />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children) {
    t8 = <div className="mt-4">{children}</div>;
    $[14] = children;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t6 || $[18] !== t8) {
    t9 = <div className={t1}>{t2}{t6}{t7}{t8}</div>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}